import React from "react"
import Image from "../image/image.js"
import "./style.scss"
import { Helmet } from "react-helmet"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Autoplay } from "swiper"

const Header = ({ title, bannerImage, metaDescription }) => {
  SwiperCore.use([Autoplay])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title} | ACME Produzioni</title>
        <meta name="description" content={metaDescription} />
        <link
          rel="icon"
          href="https://static.acmeproduzioni.it/acme/favicon.ico"
        />
      </Helmet>
      <div className="header">
        <div className="title">
          <h1>{title}</h1>
        </div>
        {typeof bannerImage === "object" ? (
          <div className="slidingBanner">
            <Swiper
              spaceBetween={0}
              slidesPerView={1}
              grabCursor={true}
              loop={true}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
            >
              {bannerImage.map(i => (
                <SwiperSlide key={i.id}>
                  <Image filename={i.filename} alt={i.alt} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <Image filename={bannerImage} alt={title} />
        )}
      </div>
    </>
  )
}

export default Header
